<template>
  <a class="button is-primary is-inverted is-outlined is-small" @click="toggleDarkTheme">{{ buttonText }}</a>
</template>

<script>
import state from '../state'

export default {
  computed: {
    enabled () {
      return state.darkThemeEnabled
    },
    buttonText () {
      if (this.enabled) {
        return 'Deactivate Dark Theme'
      }

      return 'Activate Dark Theme'
    },
  },

  methods: {
    toggleDarkTheme () {
      state.darkThemeEnabled = !state.darkThemeEnabled
      localStorage.setItem('dark-theme-enabled', state.darkThemeEnabled)
    },
  },
}
</script>

<style lang="sass" scoped>
@import '../sass/variables'
@import '~bulma/sass/utilities/variables'

.button
  transition: all 150ms ease-out
</style>



// WEBPACK FOOTER //
// ToggleDarkTheme.vue?558afade